/**
 * Cliente HTTP de los módulos de la economía.
 *
 * Existe por dos razones. La ruta base de un módulo (`/api/economy/<módulo>`) se
 * escribe en un solo sitio, en vez de armarla a mano en cada llamada y descubrir el
 * typo en producción. Y el token: `../api.ts` ya resuelve el `Bearer` y la traducción
 * de códigos de error a mensajes, y pasarlo a mano en cada sitio es exactamente cómo
 * se acaba con un endpoint que se olvidó de mandarlo.
 *
 * Un módulo pone sus llamadas en su propio archivo de este directorio, escritas sobre
 * estos tres helpers.
 *
 * Los mensajes de error sí van a un sitio compartido: el mapa `MESSAGES` de
 * `../api.ts`. Es una línea por código.
 */
import type { EconomyModuleId } from "@clubap/shared";
import { authedJson, authedRequest } from "../api.js";

function endpoint(module: EconomyModuleId, path: string): string {
  return `/api/economy/${module}${path.startsWith("/") ? path : `/${path}`}`;
}

/** GET autenticado a un endpoint del módulo, con el cuerpo JSON tipado. */
export function economyGet<T>(module: EconomyModuleId, path: string): Promise<T> {
  return authedJson<T>(endpoint(module, path));
}

/** POST autenticado que devuelve JSON. El cuerpo vacío por defecto es lo normal acá. */
export function economyPost<T>(
  module: EconomyModuleId,
  path: string,
  body: unknown = {},
): Promise<T> {
  return authedJson<T>(endpoint(module, path), body);
}

/** POST autenticado sin respuesta útil. El error se traduce igual. */
export function economySend(
  module: EconomyModuleId,
  path: string,
  body: unknown = {},
): Promise<void> {
  return authedRequest(endpoint(module, path), body);
}
